export enum CountOptions {
  NoCount = 0,
  CountAll = 1,
}
